"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginDescription = exports.LoginHeader = void 0;
const ui_theme_1 = require("@kyruus/ui-theme");
const styled_1 = __importDefault(require("@emotion/styled"));
exports.LoginHeader = styled_1.default.span `
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_5')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  line-height: 32px;
`;
exports.LoginDescription = styled_1.default.span `
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  line-height: 26px;
`;
//# sourceMappingURL=EhrLoginLogout.styles.js.map